module.exports = __webpack_public_path__ + "static/media/social2.5f48cd9f.png";